import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import Modal from "@/components/site/Modal";

export default function Services() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", category: "Studio", rate: 0, unit: "session" });
  const load = () => api.get("/admin/services").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/services", { ...form, rate: Number(form.rate) }); toast.success("Service added"); setOpen(false); setForm({ name: "", category: "Studio", rate: 0, unit: "session" }); load(); }
    catch { toast.error("Save failed"); }
  };
  const del = async (id) => { if (!confirm("Delete?")) return; await api.delete(`/admin/services/${id}`); load(); };

  const grouped = rows.reduce((a, s) => { (a[s.category] = a[s.category] || []).push(s); return a; }, {});

  return (
    <div data-testid="admin-services">
      <div className="flex items-center justify-between mb-8">
        <div><div className="label-mono mb-2">/ Catalog</div><h1 className="font-display text-4xl font-bold tracking-tighter">Services</h1></div>
        <button onClick={() => setOpen(true)} className="glass-btn solid" data-testid="service-new"><Plus size={14}/> New Service</button>
      </div>

      {Object.entries(grouped).map(([cat, items]) => (
        <div key={cat} className="mb-8">
          <div className="label-mono mb-3 text-cyan-400">/ {cat}</div>
          <div className="rounded-2xl border border-white/5 bg-[#121215] overflow-hidden">
            {items.map((s) => (
              <div key={s.id} className="flex items-center justify-between px-5 py-3 border-b border-white/5 last:border-0" data-testid={`service-row-${s.id}`}>
                <div>
                  <div>{s.name}</div>
                  <div className="text-zinc-500 text-xs font-mono">${s.rate.toFixed(2)} / {s.unit}</div>
                </div>
                <button onClick={() => del(s.id)} className="glass-btn ghost p-2" data-testid={`service-del-${s.id}`}><Trash2 size={14}/></button>
              </div>
            ))}
          </div>
        </div>
      ))}

      <Modal open={open} onClose={() => setOpen(false)} title="New Service" testid="service-modal">
        <form onSubmit={save} className="space-y-3" data-testid="service-form">
          <div><label className="label-mono block mb-2">Name *</label><input required className="pulse-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="svc-name"/></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="label-mono block mb-2">Category</label>
              <select className="pulse-input" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
                <option>Studio</option><option>Video</option><option>Film</option><option>Other</option>
              </select>
            </div>
            <div><label className="label-mono block mb-2">Unit</label>
              <select className="pulse-input" value={form.unit} onChange={(e) => setForm({ ...form, unit: e.target.value })}>
                <option>session</option><option>day</option><option>project</option><option>song</option><option>hour</option>
              </select>
            </div>
          </div>
          <div><label className="label-mono block mb-2">Rate ($) *</label><input required type="number" step="0.01" className="pulse-input" value={form.rate} onChange={(e) => setForm({ ...form, rate: e.target.value })} data-testid="svc-rate"/></div>
          <button className="glass-btn solid w-full justify-center" data-testid="svc-save">Save</button>
        </form>
      </Modal>
    </div>
  );
}
